import { InlineLoader } from '@dealstack/frontend/shared/components/loaders/InlineLoader/InlineLoader';
import { Modal } from '@mantine/core';
import { forwardRef, lazy, Suspense } from 'react';
import styled from 'styled-components';
import type { PdfViewerProps } from './PdfViewer.types';

const PdfViewer = lazy(() =>
	import('@dealstack/frontend/shared/components/DocumentViewerV2/PdfViewer/PdfViewer').then(
		(m) => ({ default: m.PdfViewer })
	)
);

interface Props {
	opened: boolean;
	onClose: () => void;
	pdfViewerProps: PdfViewerProps;
	className?: string;
}

const PdfViewerModal = forwardRef<HTMLDivElement, Props>(
	({ className, opened, onClose, pdfViewerProps }, ref) => {
		return (
			<Modal
				className={className}
				opened={opened}
				onClose={onClose}
				size="80vw"
				centered
				trapFocus={false}
				withCloseButton={false}
			>
				<Suspense fallback={<InlineLoader />}>
					<PdfViewer
						{...pdfViewerProps}
						onBackArrowClick={onClose}
						onCancelPassword={onClose}
						ref={ref}
					/>
				</Suspense>
			</Modal>
		);
	}
);

const Styled = styled(PdfViewerModal)`
	.mantine-Modal-body {
		min-height: 90vh;
		max-height: 90vh;
		display: flex;
		flex-direction: column;
		gap: 1rem;
		overflow: hidden;
	}
`;

export { Styled as PdfViewerModal };
